module.exports = __webpack_public_path__ + "img/11.15f044d3.jpg";